exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar-brand-box[data-v-d2f409fc]{background-color:#fff!important}.avatar-title[data-v-d2f409fc]{border:1px solid beige}.avatar-sm[data-v-d2f409fc]{height:2rem;width:3rem}.noti-icon-pos[data-v-d2f409fc]{position:absolute;top:12px}.text-reset[data-v-d2f409fc]{width:55px!important}", ""]);

// exports
